interface GetBoardCoverParams {
  boardIndex?: number;
}

export const FAVORITES_BOARD_GRADIENT: string =
  'https://uppbeat.imgix.net/boards/boards-gradient-1.png';

export const BOARD_GRADIENTS: Record<string, string> = {
  '1': 'https://uppbeat.imgix.net/boards/boards-gradient-2.png',
  '2': 'https://uppbeat.imgix.net/boards/boards-gradient-3.png',
  '3': 'https://uppbeat.imgix.net/boards/boards-gradient-4.png',
  '4': 'https://uppbeat.imgix.net/boards/boards-gradient-5.png',
  '5': 'https://uppbeat.imgix.net/boards/boards-gradient-6.png',
  '6': 'https://uppbeat.imgix.net/boards/boards-gradient-7.png',
  '7': 'https://uppbeat.imgix.net/boards/boards-gradient-8.png',
  '8': 'https://uppbeat.imgix.net/boards/boards-gradient-6.png',
  '9': 'https://uppbeat.imgix.net/boards/boards-gradient-4.png',
};

const AVAILABLE_GRADIENTS = Object.keys(BOARD_GRADIENTS).length;

export const getBoardCover = ({ boardIndex }: GetBoardCoverParams) => {
  if (typeof boardIndex === 'undefined') {
    const max = 9;
    const min = 1;
    // create random integer between 1 and 9 inclusive
    const randomInt = Math.floor(Math.random() * (max - min + 1) + min);
    return BOARD_GRADIENTS[randomInt];
  }

  if (boardIndex === 0) {
    return FAVORITES_BOARD_GRADIENT;
  }

  if (boardIndex < 10) {
    return BOARD_GRADIENTS[boardIndex];
  }

  const remainder = boardIndex % AVAILABLE_GRADIENTS;

  const key = remainder === 0 ? 1 : remainder;

  return BOARD_GRADIENTS[key];
};
